<div *ngIf="!processingLogin && notification" id="notification" class="dds__alert" data-dismiss="dds__alert" aria-expanded="true" role="alert">
  <div class="dds__less">
    <div class="dds__d-flex dds__justify-content-between">
      <div class="dds__alert-heading dds__d-flex dds__align-items-center">
          <svg class="dds__icons dds__svg-icons custom-svg" [ngClass]="notificationMap.get(notification.status)" aria-hidden="true">
            <use [attr.xlink:href]="notificationMapForId.get(notification.status)" aria-hidden="true" />
          </svg>
        <h4 >{{notification.msg}}</h4>
      </div> <button type="button"  class="dds__icons dds__close-x" (click)="closeNotificaion()"
        [attr.aria-label]="notification"></button>
    </div>

  </div>
</div>
